
import Vue from 'vue'
import { VToolbarTitle } from 'vuetify/lib'
import JcdcLogo from '@/components/jcdc/JcdcLogo.vue'

export default Vue.extend({
  name: 'JcdcTitleBar',
  components: {
    JcdcLogo,
    VToolbarTitle,
  },
  props: {
    appTitle: { type: String, required: true },
    appSubtitle: { type: String, required: true },
    extHomeUrl: { type: String, default: undefined },
    appEnvironment: { type: String, default: 'production' },
    noHomeUrl: { type: Boolean, default: false },
  },
  computed: {
    homeRoute() {
      const path = this.$route
      if (path) {
        const x = path.matched[0],
          home = x.path ? { name: x.name } : x.redirect
        return home
      }
      return '/'
    },
  },
})
